import React from 'react';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import styled from '@emotion/styled';
import { useAutoTranslation } from '../../helpers/useAutoTranslation';

const Wrapper = styled(ResponsiveContainer)`
  .recharts-wrapper .recharts-cartesian-grid-vertical line:nth-last-of-type(-n + 2) {
    stroke-opacity: 0;
  }

  .recharts-tooltip-item {
    padding: 0 !important;
    margin-top: 2px;
  }
`;

const AverageCheckChart = (props) => {
  const { title, weeklyValue, monthlyValue, allTimeValue, data, formatNumber, keyToLabel } = props;

  const { t } = useAutoTranslation();
  return (
    <div className="col-xl-4 col-md-6">
      <div className="card">
        <div className="card-body">
          <h4 className="header-title mb-0">{title}</h4>
          <div className="collapse pt-3 show">
            <div className="text-center">
              <div className="row mt-2">
                <div className="col-4">
                  <h4>{formatNumber(weeklyValue)}</h4>
                  <p className="text-muted font-13 mb-0 text-truncate">{t('За неделю')}</p>
                </div>
                <div className="col-4">
                  <h4>{formatNumber(monthlyValue)}</h4>
                  <p className="text-muted font-13 mb-0 text-truncate">{t('За месяц')}</p>
                </div>
                <div className="col-4">
                  <h4>{formatNumber(allTimeValue)}</h4>
                  <p className="text-muted font-13 mb-0 text-truncate">{t('За всё время')}</p>
                </div>
              </div>
              <div className="mt-3">
                <Wrapper width="100%" height={300}>
                  <BarChart
                    width={730}
                    height={250}
                    data={data}
                    margin={{ top: 0, right: 30, left: 0, bottom: 0 }}
                  >
                    <CartesianGrid
                      vertical={false}
                      stroke="#f5f5f5"
                      strokeWidth={1}
                      active={false}
                    />
                    <XAxis
                      dataKey="point"
                      axisLine={false}
                      tickLine={false}
                      tick={{ fill: `#98a6ad` }}
                    />
                    <YAxis
                      tickFormatter={(value) => formatNumber(value)}
                      tickCount={5}
                      axisLine={false}
                      tickLine={false}
                      tick={{ fill: `#98a6ad` }}
                    />
                    <Tooltip
                      cursor={false}
                      formatter={(value) => [value, `Средний чек`]}
                      labelFormatter={(key) => keyToLabel[key]}
                      contentStyle={{
                        border: `none`,
                        boxShadow: `0 1px 4px 0 rgba(0, 0, 0, 0.1)`,
                        borderRadius: `0.25rem`,
                        opacity: `0.95`,
                        fontWeight: 500,
                        backdropFilter: `blur(2px)`,
                      }}
                      labelStyle={{
                        fontWeight: 600,
                        marginBottom: 5,
                        textAlign: `left`,
                      }}
                    />
                    <Bar dataKey="amount" fill="#4fc6e1" barSize={8} />
                  </BarChart>
                </Wrapper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AverageCheckChart;
